import "./style.scss"
import MarketsTop from "components/Secondary/MarketsTop";
import OpenOrdersTable from "./OpenOrdersTable";
import OpenOrdersAccountsTable from "./OpenOdersAccountsTable";

const OpenOrders = ({}) => {

  return <div className="openOrders">
    <div className="openOrdersTable">
      <MarketsTop title={"Open Orders"} actionTitle={"Close All"}/>
      <OpenOrdersTable/>
    </div>

    <div className="openOrdersAccountsTable">
      <MarketsTop 
      title={"Open Orders Account"} 
      info={"some info"} 
      actionTitle={"Close All & Claim SOL"}
      status={"1.53 SOL Claimable"}/>
      <OpenOrdersAccountsTable/>
    </div>
  </div>
}

export default OpenOrders;